<template>
  <div class="library-file__meta">
    <div
      class="library-file__meta-icon"
      :style="{ background: typeIcon.color }"
    >
      <v-icon>{{ typeIcon.icon }}</v-icon>
    </div>
    <div class="library-file__meta-icon">
      <profile-preview-image
        :profileId="createdById"
        :avatarSize="24"
      />
    </div>
    <div class="library-file__meta-text">
      <span class="date">{{ creationDate | moment('MMMM Do, YYYY') }}</span>
      <span class="name">{{ createdByName }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
export default {
  name: 'LibraryAuthorMeta',
  components: {
    ProfilePreviewImage
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    creationDate: {
      type: String,
      default: '',
    },
    createdById: {
      type: Number,
      default: 0,
    },
    type: {
      type: [Boolean, Number],
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      createdByName: ''
    }
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    ...mapState('dictionariesStates', ['dictionaryFileType']),
    typeIcon() {
      let typeObj = {
        color: '',
        icon: '',
      }
      if (this.type) {
        let typeName = this.dictionaryFileType[this.type]
        switch (typeName) {
          case 'video':
            typeObj.color = '#FF6760'
            typeObj.icon = 'bhi-play-circle'
            break
          case 'unknown':
            typeObj.color = '#45C2F4'
            typeObj.icon = 'bhi-file'
            break
          case 'picture':
            typeObj.color = '#FAC032'
            typeObj.icon = 'bhi-image'
            break
          case 'pdf':
            typeObj.color = '#E74F48'
            typeObj.icon = 'bhi-icon-pdf'
            break
          case 'word':
            typeObj.color = '#00A0E0'
            typeObj.icon = 'bhi-icon-word'
            break
          case 'presentation':
            typeObj.color = '#FF7E77'
            typeObj.icon = 'bhi-icon-presentation'
            break
          case 'spreadsheet':
            typeObj.color = '#34EEAE'
            typeObj.icon = 'bhi-icon-spreadsheet'
            break
          default:
            typeObj.color = '#45C2F4'
            typeObj.icon = 'bhi-file'
            break
        }
      }
      return typeObj
    },
  },
  methods: {
    setCreatedByName(profiles) {
      const profile = profiles.find(el => el.profileId === this.createdById)

      if (profile) {
        this.createdByName = profile.fullName || profile.firstName + ' ' + profile.lastName
      }
    }
  },
  watch: {
    profilePreviews(newProfiles) {
      this.setCreatedByName(newProfiles)
    }
  },
  created() {
    this.setCreatedByName(this.profilePreviews)
  }
}
</script>

<style lang="scss">
.library-file__meta {
  display: flex;
  margin-bottom: 10px;
  &-icon {
    width: 24px;
    height: 24px;
    text-align: center;
    border-radius: 6px;
    overflow: hidden;
    margin-right: 6px;
    &.type-clip {
      background: $bh-red;
    }
    &.type-photo {
      background: $bh-yellow;
    }
    .v-icon {
      color: $bh-white;
      font-size: 12px;
    }
    .v-image {
      min-height: 100%;
    }
  }
  &-text {
    display: flex;
    flex-direction: column;
    .date {
      display: block;
      color: $bh-gray--2;
      font-size: 10px;
      line-height: 13px;
    }
    .name {
      color: $bh-gray;
      font-size: 8px;
      line-height: 10px;
    }
  }
}
</style>
